import PropTypes from "prop-types"
import { get } from "lodash"
import { TableRow, TableCell } from "@mui/material"
import { numberFormatter } from "helpers/formatters/numbers"
import ContributorsTableHead from "components/contributors-table-head"

function ContributorsDetailsTableTopRow({ name, hide, selectedGroupSiblings, groupsDropdownColumns, groupChange, selectedGroup, ...props }) {
  return (
    <TableRow {...props}>
      <ContributorsTableHead
        label={name}
        color="#da7c30"
        onBackClick={hide}
        dropdownColumns={groupsDropdownColumns}
        dropdownItems={selectedGroupSiblings}
        onDropdownItemClick={(group) => groupChange(group)}
        selectedItemId={get(selectedGroup, "id")}
      />
      <TableCell align="right" style={{ color: "#da7c30" }}>{numberFormatter(get(selectedGroup, "totalPercentEquity") * 100) || "-"}</TableCell>
    </TableRow>
  )
}

ContributorsDetailsTableTopRow.propTypes = {
  name: PropTypes.string.isRequired,
  hide: PropTypes.func.isRequired,

  selectedGroupSiblings: PropTypes.array,
  groupsDropdownColumns: PropTypes.array,
  groupChange: PropTypes.func,
  selectedGroup: PropTypes.object,
}

export default ContributorsDetailsTableTopRow
